<div class="button-content" matRipple>
  <core-icon
    [class.placeholder-icon]="!icon && placeholderIcon"
    [icon]="actionInProgress ? 'loading' : icon || placeholderIcon"
    [material]="material"
    [size]="iconSize">
  </core-icon>
</div>
